import { render, staticRenderFns } from "./ContrastIcon.vue?vue&type=template&id=bcfdf672&"
import script from "./ContrastIcon.vue?vue&type=script&lang=js&"
export * from "./ContrastIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports